module.exports = __webpack_public_path__ + "static/media/mobile2.8fe744b0.webp";